<template>
	<div class="col-md-4 col-md-offset-4">
		<div class="panel panel-default drop-shadow">
			<div class="panel-heading panel-dark text-center">
				<b>FORGOT PASSWORD</b>
			</div>
			
            <!-- REQUEST -->
			<div v-if="email_sent == false"  class="panel-body">
				<div class="form-group">
					<div class="col-md-4">
						<label class="control-label text-right" style='padding-top:7px; width:100%;' >
							<b>Email:</b>
						</label>
					</div>
					<div class="col-md-8 text-left">
						<input  name="email"  type="text"  class="form-control" style='width:100%; v-align:middle;' autofocus
								v-validate="'required|max:250'"
								v-model="email"
						>
						<span class="text-danger">{{ errors.first('email') }}</span>
					</div>
				</div>
				<br><br><br>

				<div class="form-group">
					<div class="col-md-6 col-md-offset-6">
						<button  v-if="requesting == false"
								 name="button"  type="submit"  class="btn btn-primary btn-block"
								 @click="send_forgot()"
    							 :disabled="errors.any() || !is_complete"
						>Submit</button>

						<button v-else  disabled
								name="button"   type="submit"  class="btn btn-primary btn-block">
							<i class="fas fa-circle-notch fa-spin"></i>
						</button>
					</div>
				</div>
			</div>

            <!-- REQUEST SENT -->
			<div v-else                      class="panel-body">
				<div class="form-group">
                    An email has been sent with instructions on how to reset your password.
				</div>
				<br><br><br>

				<div class="form-group">
					<div class="col-md-6 col-md-offset-6">
						<button  name="button"  type="submit"  class="btn btn-primary btn-block"
								 @click="complete()"
						>OK</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
//imports...

export default {
	components: {
	},

    computed: {
        is_complete() {
            return this.email;
        },
    },

	data() {
		return {
			requesting: false,
			email:      '',
            password:   '',
            
            email_sent: false,
		};
	},

	methods: {
		// User login Method
		send_forgot() {
			this.requesting = true;
			
			this.$validator.validateAll()
			.then(() => {
				const post_data = {
					email:    this.email,
				};

				this.axios.post('api/forgot', post_data)
				.then(response => {
					this.$notify({
						group:    'fs_success',
						title:    'Success',
						text:     'Request sent',
						duration: 3000,
						type:     'success'
					});
					
					this.requesting = false;
					this.email_sent = true;
				})
				.catch(error => {
					this.requesting = false;
			
					var error_msg     = '';
					var error_details = '';
					if (error.response.data.message) {
						error_msg = error.response.data.message;	
					}
					
					if (error.response.data.error) {
						Object.keys(error.response.data.error).forEach(key => {
							error_details = error_details + error.response.data.error[key].toString() + "<br>";

							// load api errors into client errors
							this.errors.add({
								field: key,
								msg:   error.response.data.error[key].toString(),
							});
						});
					}

                    this.$notify({
                        group: 'fs_danger',
                        title: error_msg,
                        text:  error_details,
                        type:  'error'
                    });
				});
			})
			.catch(() => {
				this.requesting = false;
			
				this.$notify({
					group: 'fs_danger',
					title: 'Error',
					text:  this.errors.all(),
					type:  'error'
				});
			});
        },
        
		// Close form
		complete() {
            this.$router.push('/home-old');
		},
	}
};
</script>

<style lang="scss">
</style>